import client from './client';

export function checkSetup() {
  return client.get('/api/auth/setup', { skipAuth: true });
}

export function login(payload) {
  return client.post('/api/auth/login', payload, { skipAuth: true });
}

export function setup(payload) {
  return client.post('/api/auth/setup', payload, { skipAuth: true });
}

export function getProfile() {
  return client.get('/api/auth/profile');
}

export function logout() {
  return client.post('/api/auth/logout', {});
}

export function getSettings() {
  return client.get('/api/auth/settings', { skipAuth: true });
}

export function getAdminSettings() {
  return client.get('/api/auth/settings/admin');
}

export function saveSettings(payload) {
  return client.post('/api/admin/settings', payload);
}

export function sendTestEmail() {
  // The recipient is fixed server-side (the requesting admin's account email),
  // so no payload is needed or honored.
  return client.post('/api/admin/settings/test-email');
}

export function getNotificationPreferences() {
  return client.get('/api/notifications/preferences');
}

export function saveNotificationPreferences(payload) {
  return client.put('/api/notifications/preferences', payload);
}

export function changePassword(payload) {
  return client.post('/api/auth/change-password', payload);
}

export function updateProfile(payload) {
  return client.put('/api/auth/profile', payload);
}
